var render, staticRenderFns
import script from "./DeliveryPage.vue?vue&type=script&lang=ts&"
export * from "./DeliveryPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeliveryPage.vue"
export default component.exports